module.exports = __webpack_public_path__ + "assets/img/block-left-hover-620f5cc9.png";